import type React from 'react';
import { styled } from 'styled-components';

import Icons from '../../../Elements/Icons/index.tsx';

const UploadingErrorStyle = styled.div`
  color: ${({ theme }) => theme.colors.critical70};
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 4px;
  margin: 4px 0;
`;

export const UploadingError = ({ children }: React.PropsWithChildren) => (
  <UploadingErrorStyle data-testid='uploading-error'>
    <Icons.WarningCircleAlt size={20} color='currentColor' />
    {children}
  </UploadingErrorStyle>
);
